<div class="my-blog-component-container">
  <ng-template #gotoLink>
    <app-action-link [href]="blogCenterUrl" [target]="'blank'">
      <span i18n="blog see all blog link@@blog-see-all-blog-link">Go to the blog center</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-link>
  </ng-template>

  <div class="d-none d-md-block float-md-right mt-1">
    <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
  </div>
  <h2 i18n="my blog title@@my-blog-title" class="widget-header h4 my-news-title">Blog posts</h2>
  <span class="text-muted" i18n="blog my blog sub title@@news-my-news-sub-title">Here you'll find the latest blog posts from your personal feed. Update your selected channels on your <a routerLink="/settings" class="settings-link action">settings page</a>. When you click on a post, it will open in a new tab. You can navigate back here at any time by closing or switching the tab.</span>
  <div class="d-block d-md-none mt-2 mt-md-0">
    <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
  </div>

  <div class="my-blog-item-container">
    <div *ngIf="personalBlogItems$ | async as personalBlogItems; else innerLoading">
      <div *ngIf="personalBlogItems && personalBlogItems.length > 0">
        <app-news-card-list [personalNewsItems]='personalBlogItems'></app-news-card-list>
      </div>

      <div *ngIf="personalBlogItems && personalBlogItems.length === 0">
        <app-text-placeholder>
          <p i18n="my blog none found@@my-blog-none-found">No blog posts could be found according to your channel selections.</p>
        </app-text-placeholder>
      </div>

      <div *ngIf="loading" class="mt-4">
        <div *ngIf="errorSubject$ | async as err; else innerLoading">
          <app-error-templates [error]="err.status"></app-error-templates>
        </div>
      </div>
    </div>
  </div>

  <ng-template #innerLoading>
    <div class="mt-4">
      <app-widget-placeholder></app-widget-placeholder>
    </div>
  </ng-template>

  <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfPosts > amountOfBlogPostsToDisplayCurrently && !loading && numberOfShowMoreClicks < maxNumberOfShowMore else linkToBlogCenter">
    <div class="col-auto">
      <button mat-flat-button color="accent" class="blog-show-more-btn" (click)="showMoreBlogPosts()"><span i18n="my blog show more@@my-blog-show-more">Show more blog posts</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i></button>
    </div>
  </div>

  <ng-template #linkToBlogCenter>
    <div class="col-auto mt-4 text-center" *ngIf="!loading">
      <span i18n="@@more-blog-in-news-center">For older blog posts, open <app-action-link [href]="blogCenterUrl" [target]="'blank'">Blog Center</app-action-link></span>
    </div>
  </ng-template>
</div>
